import React from 'react';
import { Button } from './ui/Button';
import { Calendar } from 'lucide-react';
export function NewsSection() {
  const news = [{
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&h=400&fit=crop&q=80',
    date: '15 Лютого 2024',
    title: 'Огляд ключових досягнень року 2024',
    description: 'Підбиваємо підсумки нашої роботи за минулий рік. Вдалося реалізувати понад 50 успішних кейсів захисту прав гравців.'
  }, {
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=400&fit=crop&q=80',
    date: '10 Лютого 2024',
    title: 'Запущено нову навчальну програму',
    description: 'Стартує курс з фінансової грамотності для гравців. Реєстрація вже відкрита для всіх бажаючих.'
  }, {
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop&q=80',
    date: '05 Лютого 2024',
    title: 'Партнерство розширює наш вплив',
    description: 'Підписано меморандум про співпрацю з міжнародною асоціацією чесної гри. Це відкриває нові можливості.'
  }];
  return <section id="news" className="py-20 bg-white" data-id="element-171">
      <div className="container mx-auto px-4" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-174">
            Останні новини з нашого простору
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-175" />
          <p className="text-gray-600 text-lg" data-id="element-176">
            Слідкуйте за нашими оновленнями та подіями
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177">
          {news.map((item, index) => <div key={index} className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col" data-id="element-178">
              <div className="relative h-48 overflow-hidden" data-id="element-179">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-180" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-medium text-[#0A5E5C] flex items-center gap-1" data-id="element-181">
                  <Calendar size={12} data-id="element-182" />
                  {item.date}
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-183">
                <h3 className="text-xl font-serif font-bold text-[#0A5E5C] mb-3 group-hover:text-[#D4A843] transition-colors" data-id="element-184">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-6 text-sm leading-relaxed flex-grow" data-id="element-185">
                  {item.description}
                </p>
                <Button variant="primary" size="sm" fullWidth data-id="element-186">
                  Читати далі
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}